import styled from "@emotion/styled";
import React from "react";

import DesktopMenu from "./deskTopMenu";
import MobileMenu from "./mobileMenu";
import { MenuContainer } from "./styles";

const MenuList = [
  ["Home", "/#"],
  ["Dollar Inu", "/#dollarinu"],
  ["Sacrifice", "#sacrifice"],
  ["Roadmap", "#roadmap"],
  ["Collabs", "#collabs"],
  ["F.A.Q's", "#faq"],
  ["Telegram", "#telegram"],
  ["Connect Wallet", "/#"],
];
const checkSticky = "";
const Menu = () => {
  return (
    <MenuContainer>
      <DesktopMenu menuList={MenuList} />
      <MobileMenu menuList={MenuList} />
    </MenuContainer>
  );
};

export default Menu;
